<template>
  <div class="group-setup">
    <v-progress-linear
      indeterminate
      color="orange"
      v-if="loading"
    ></v-progress-linear>
    <v-layout row v-if="errors">
      <v-flex>
        <Alert @dismissed="onDismissed" :text="errors"></Alert>
      </v-flex>
    </v-layout>
    <v-card class="pa-5">
      <v-card-title dark>
        <h3 class="ma-2">Participation at Cabinet Installation Ceremony</h3>
      </v-card-title>
      <v-divider></v-divider>
      <v-form>
        <v-row>
          <v-col cols="6" md="6" sm="12">
            <v-switch
              v-model="form.president_attended"
              label="President attended"
              value="1"
              hide-details
            ></v-switch>
          </v-col>
          <v-col cols="6" md="6" sm="12">
            <v-switch
              v-model="form.secretary_attended"
              label="Secretary attended"
              value="1"
              hide-details
            ></v-switch>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" md="6" sm="12">
            <v-switch
              v-model="form.treasurer_attended"
              label="Treasurer attended"
              value="1"
              hide-details
            ></v-switch>
          </v-col>
          <v-col cols="6" md="6" sm="12">
            <v-switch
              v-model="form.membership_director_attended"
              label="Membership Director of the club"
              value="1"
              hide-details
            ></v-switch>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" md="6" sm="12">
            <v-text-field
              outlined
              dense
              v-model="form.no_of_other_members"
              label=" No of other members"
              required
              type="number"
            ></v-text-field>
          </v-col>
          <v-col cols="6" md="6" sm="12">
            <v-text-field
              outlined
              dense
              v-model="form.no_of_lions_ladies"
              label=" No of lions ladies"
              required
              type="number"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" md="6" sm="12">
            <v-file-input
              outlined
              dense
              filled
              v-model="form.document1"
              prepend-icon="mdi-paperclip"
              label="Attach a copy of the certificate"
            ></v-file-input>
            <small>Max Size 2Mb </small>
          </v-col>
          <v-col cols="6" md="6" sm="12">
            <v-file-input
              outlined
              dense
              filled
              v-model="form.document2"
              prepend-icon="mdi-paperclip"
              label="Attach a copy of attendance sheet"
            ></v-file-input>
            <small>Max Size 2Mb </small>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" md="6" sm="12">
            <v-file-input
              outlined
              dense
              filled
              v-model="form.document3"
              prepend-icon="mdi-paperclip"
              label="Photo 1"
            ></v-file-input>
            <small>Max Size 2Mb </small>
          </v-col>
          <v-col cols="6" md="6" sm="12">
            <v-file-input
              outlined
              dense
              filled
              v-model="form.document4"
              prepend-icon="mdi-paperclip"
              label="Photo 2"
            ></v-file-input>
            <small>Max Size 2Mb </small>
          </v-col>
        </v-row>
      </v-form>
      <v-divider></v-divider>
      <v-card-actions v-if="!cpRole">
        <v-row>
          <v-col cols="12" md="9" xs="6"></v-col>
          <v-col cols="12" md="3" xs="6">
            <v-btn
              large
              color="success"
              depressed
              :disabled="loading || !form.president_attended"
              block
              @click="submit()"
              >Submit to Review</v-btn
            >
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");
import Alert from "@/components/shared/Alert";
import { ActivityService } from "../../../services/activity-service.js";
import { checkError } from "@/config/errors.js";

export default {
  name: "CabinetInstallationCeremony",

  components: { Alert },

  data: () => ({
    cpRole: false,
    loading: false,
    errors: null,
    snackbar: false,
    successMsg: "",
    form: {
      no_of_other_members: 0,
      president_attended: 0,
      secretary_attended: 0,
      treasurer_attended: 0,
      no_of_lions_ladies: 0,
      membership_director_attended: 0,
      document1: null,
      document2: null,
      document3: null,
      document4: null,
    },

    url: "cabinet-installation-ceremony",
  }),

  mounted() {},

  computed: {
    ...mapGetters({
      member: "profile",
    }),
  },

  methods: {
    submit() {
      this.errors = null;
      this.loading = true;
      this.snackbar = false;
      let fd = new FormData();

      fd.append("document1", this.form.document1);
      fd.append("document2", this.form.document2);
      fd.append("document3", this.form.document3);
      fd.append("document4", this.form.document4);

      fd.append("no_of_lions_ladies", this.form.no_of_lions_ladies);
      fd.append("no_of_other_members", this.form.no_of_other_members);
      fd.append("president_attended", this.form.president_attended == null ? 0 : this.form.president_attended);
      fd.append("secretary_attended", this.form.secretary_attended == null ? 0 : this.form.secretary_attended);
      fd.append("treasurer_attended", this.form.treasurer_attended == null ? 0 : this.form.treasurer_attended);
      fd.append("membership_director_attended", this.form.membership_director_attended == null ? 0 : this.form.membership_director_attended);
            fd.append("month", this.$route.params.month);
      fd.append("key", "PARTICIPATION_CABINET_INSTALLATION_CEREMONY");

      let data = fd;
      ActivityService.submitActivity(this.url, data)
        .then((response) => {
          this.loading = false;
          if (response.data.data) {
            this.$router.push("/activities/monthly");
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },

    onDismissed() {
      this.errors = null;
    },
    closeSnackbar() {
      this.snackbar = false;
    },
    reset() {
      this.form.name = "";
    },
  },
};
</script>
